import { useEffect, useState } from "react";
import "./CustomStory.css";

interface BodyProps {
    id: number;
    body_copy: string;
    title?: string;
    date_posted?: string;
}

function CustomBodyComponent({ id, body_copy, title, date_posted }: BodyProps) {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => setWindowWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return (
        <section
            className="body-copy"
            style={{
                width: windowWidth > 575 ? "70%" : "90%",
                margin: "0 auto 100px auto",
                textAlign: "left",
            }}
        >
            {(title || date_posted) && (
                <header className="body-header">
                    {title && <p className="body-title">{title}</p>}
                    {date_posted && <p className="body-date">{date_posted}</p>}
                </header>
            )}
            <div
                className="body-content"
                dangerouslySetInnerHTML={{ __html: body_copy }}
            />
        </section>
    );
}

export default CustomBodyComponent;
